import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filterLetters: '',
  column:        '',
  sortOrder:     '',
  page:          1,
}

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilterLetters: (state, action) => {
      state.filterLetters = action.payload
      state.page = 1
    },
    toggleSort: (state, action) => {
      if (state.column === action.payload) {
        state.sortOrder = state.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        state.column    = action.payload
        state.sortOrder = 'asc'
      }
      state.page = 1
    },
    setPage: (state, action) => {
      state.page = action.payload
    },
  },
})

export const { setFilterLetters, toggleSort, setPage } = filtersSlice.actions
export const filtersReducer = filtersSlice.reducer
